// extracted by css-extract-rspack-plugin
export default {"deletedCommentAuthorLink":"CommentDeletedEvent-module__deletedCommentAuthorLink__tRoVn"};